//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { call } from 'vuex-pathify'
import UsuarioTags from '@/api/promotores/usuarios/tags.api'
import ChipSkeleton from '@/components/Skeletons/ChipSkeleton'
import TagsSelectDialog from './TagsSelectDialog'

export default {
  components: { ChipSkeleton },

  data() {
    return {
      tags: [],
      loading: false,
      updating: false,
    }
  },

  mounted() {
    this.loadTags()
  },

  methods: {
    search: call('app/search'),

    async loadTags() {
      try {
        this.loading = true
        const tags = await UsuarioTags.all(this.$route.params.promotor)
        this.tags = tags.filter(tag => tag.slug !== 'tareas-cierralo-tu')
      } finally {
        this.loading = false
      }
    },

    async removeTag(tag) {
      try {
        this.updating = true;
        const response = await UsuarioTags.delete(this.$route.params.promotor, tag.id);

        this.tags = this.tags.filter((item) => item.id != tag.id);
      } finally {
        this.updating = false;
      }
    },

    openTags() {
      const dialog = this.$q.dialog({
        component: TagsSelectDialog,
        selected: this.tags,
      });

      dialog.onOk(async (selected) => {
        this.updating = true

        await UsuarioTags.sync(this.$route.params.promotor, selected.map(tag => tag.id));
        this.tags = selected;

        this.updating = false
        dialog.hide();
      });
    }
  }
}
